import React, { useState } from "react";
import { faqData } from "../array";
import { CiCircleChevDown } from "react-icons/ci";
import { motion } from "framer-motion"; // Import Framer Motion

function FAQItem({ question, answer }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }} // Smoother appearance for each FAQ item
    >
      <motion.h3
        onClick={handleToggle}
        className="bg-logo gap-3 mt-3 rounded-xl p-3 font-bold flex justify-between cursor-pointer"
        whileHover={{ scale: 1.02 }} // Slight scaling on hover for the question
        transition={{ duration: 0.2 }}
      >
        {question}
        <CiCircleChevDown size={20} />
      </motion.h3>
      <motion.div
        layout // This helps with smooth expansion and collapse
        initial={{ opacity: 0, height: 0 }}
        animate={{
          opacity: isExpanded ? 1 : 0,
          height: isExpanded ? "auto" : 0,
        }}
        transition={{ duration: 0.4, ease: "easeInOut" }} // Smoother transition for answer
        style={{ overflow: "hidden" }} // Ensures a clean transition
      >
        <motion.p className="text- p-3">{answer}</motion.p>
      </motion.div>
    </motion.div>
  );
}

function FAQList() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 230">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="black" />
            <stop offset="100%" stopColor="#373AC8" />
          </linearGradient>
        </defs>
        <path
          fill="url(#gradient)"
          fillOpacity="1"
          d="M0,160L80,138.7C160,117,320,75,480,96C640,117,800,203,960,218.7C1120,235,1280,181,1360,154.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        />
      </svg>

      <div className="w-full bg-gradient-to-r from-black to-logo text-white md:px-24 pb-40 p-6">
        <div className="">
          <motion.h2
            className="md:text-3xl text-xl font-bold"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeInOut" }} // Smooth fade-in for title
          >
            Frequently Asked Questions
          </motion.h2>
          <motion.div
            className="border-t-4 border-yellow-500 mt-2 w-20 rounded-full"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} // Smooth scaling of underline
          />
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-3 mt-5">
          {faqData.map((item) => (
            <FAQItem
              key={item.id}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default FAQList;
